import * as React from 'react'

import { clsx } from 'clsx'

import styles from './SectionAvatar.module.css'

type SectionAvatarProps = {
  children: React.ReactNode
  className?: string
}

const SectionAvatar = React.forwardRef<HTMLDivElement, SectionAvatarProps>(
  ({ children, className }, forwardedRef) => (
    <div
      ref={forwardedRef}
      className={clsx(styles.root, className)}
      aria-hidden
    >
      {children}
    </div>
  ),
)

SectionAvatar.displayName = 'SectionAvatar'

export { SectionAvatar }
export type { SectionAvatarProps }
